<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-06-01 18:06:03
-->
<template>
  <div class="app-container">
    <!-- 查询条件 -->
    <div class="search-div common-section-bg">
      <div class="shaixuan-item">
        <el-input v-model="queryParam.key"
                  size="mini"
                  clearable
                  placeholder="请输入标题关键字" />
      </div>
      <div class="shaixuan-item">
        <el-select v-model="queryParam.cate_id"
                   clearable
                   placeholder="请选择栏目">
          <el-option v-for="item in optionList"
                     :key="item.id"
                     :label="item.name"
                     :value="item.id" />
        </el-select>
      </div>
      <div class="shaixuan-item">
        <el-date-picker v-model="queryParam.starttime"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="发布日期-起">
        </el-date-picker>
      </div>
      <div class="shaixuan-item">
        <el-date-picker v-model="queryParam.endtime"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="发布日期-止">
        </el-date-picker>
      </div>
      <div class="shaixuan-item">
        <el-button type="primary"
                   size="mini"
                   @click="searchClick()"
                   icon="el-icon-search">
          查询
        </el-button>
        <el-button @click="clickItem(0)"
                   type="primary"
                   size="mini"
                   icon="el-icon-plus">
          新增
        </el-button>
      </div>
    </div>
    <!-- 列表展示 -->
    <div class="common-section-bg common-section-body">
      <el-table v-loading="listLoading"
                :data="tableData"
                size="mini"
                style="width: 100%; min-height: 300px">
        <el-table-column prop="id"
                         label="id"
                         width="100" />
        <el-table-column prop="title"
                         label="文章标题" />
        <el-table-column label="栏目">
          <template slot-scope="scope">
            {{ scope.row.cate ? scope.row.cate.name : '' }}
          </template>
        </el-table-column>
        <el-table-column label="推荐">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.push_flag == 1"
                    type="success">是</el-tag>
            <el-tag v-if="scope.row.push_flag == 0"
                    type="warning">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="点击"
                         min-width="100">
          <template slot-scope="scope">
            <el-tag>{{ scope.row.hits }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="publish_at"
                         label="发布时间"
                         min-width="140" />
        <el-table-column fixed="right"
                         align="center"
                         label="操作"
                         width="180">
          <template slot-scope="scope">
            <div class="btns-wrap">
              <el-button type="danger"
                         @click="remove(scope.row)"
                         size="mini">删除</el-button>
              <el-button type="danger"
                         style="
                                    background: #1067e0;
                                    border-color: #1067e0;
                                "
                         size="mini"
                         @click="clickItem(1, scope.row)">修改</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination v-show="total"
                  :total="total"
                  :page.sync="queryParam.page"
                  :limit.sync="queryParam.size"
                  @pagination="getList" />
    </div>
    <el-drawer custom-class="custom-drawer"
               :visible.sync="showDrawer"
               :close-on-press-escape="false"
               :wrapper-closable="false"
               :show-close="false"
               size="660px">
      <template slot="title">
        <div class="custom-title">
          <div class="title-name">{{ isEdit ? "编辑" : "新增" }}</div>
          <i class="el-icon-circle-close close-btn pointer"
             @click="closeDrawerFun" />
        </div>
      </template>
      <div class="custom-content">
        <commonAdd ref="commonAdd"
                   @onUpdateDrawer="onUpdateDrawer($event)" />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import fetch from "@/api/console/Article";
import Cate from "@/api/console/Cate";
import commonAdd from "./ArticleAdd.vue";
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
export default {
  data () {
    return {
      optionList: [],
      queryParam: {
        key: "",
        cate_id: "",
        starttime: "",
        endtime: "",
        page: 1,
        size: 10,
      },
      total: 0,
      listLoading: false,
      tableData: [],
      isEdit: 0, // 0新增 1编辑
      showDrawer: false,
    };
  },
  components: {
    Pagination,
    commonAdd,
  },
  created () {
  },
  mounted () {
    this.getList();
    this.getSelect();
  },
  methods: {
    /**
     * @name: 下拉列表
     * @return {*}
     * @desc:
     */
    getSelect () {
      Cate.select({}).then((res) => {
        if (res.code == 200) {
          this.optionList = res.result
        }
      });
    },
    // 排序变更
    handleChange (row) {
      let params = {
        id: row.id,
        sort: row.sort
      };
      fetch.sort(params).then(res => {
        if (res.code == 200) {
          this.getList();
        } else {
          this.getList();
          this.$message.error(res.message);
        }
      })
    },
    /**
 * @name: 更改状态
 * @param {*} val
 * @return {*}
 * @desc: 
 */
    changeStatus (val) {
      let params = {
        id: val.id,
        status: val.status
      };
      fetch.status(params).then(res => {
        if (res.code == 200) {
          this.getList();
        } else {
          this.getList();
          this.$message.error(res.message);
        }
      })
    },
    // 更新弹层状态
    onUpdateDrawer (status) {
      console.log("status", status);
      if (status == 1) {
        // 成功
        this.showDrawer = false;
        this.getList();
      } else if (status == -1) {
        // 失败
        this.showDrawer = false;
      }
    },
    /**
     * @name: 关闭弹层
     * @return {*}
     * @desc:
     */
    closeDrawerFun () {
      this.showDrawer = false;
      this.$refs.commonAdd.resetForm();
    },
    /**
     * @name: 点击子项 0新增 1编辑
     * @param {*} type
     * @param {*} id
     * @return {*}
     * @desc:
     */
    clickItem (type, row) {
      let that = this;
      this.showDrawer = true;
      this.isEdit = type;
      // 给组件传值
      let obj = {
        type: type,
        id: row ? row.id : "",
      };
      this.$nextTick(function () {
        that.$refs.commonAdd.initFun(obj);
      });
    },
    /* 查询按钮，页码重置，查询数据 */
    searchClick () {
      this.queryParam.page = 1;
      this.getList();
    },
    /* 查询tableData数据 */
    getList () {
      let that = this;
      this.listLoading = true;
      fetch.list(that.queryParam).then((res) => {
        that.listLoading = false;
        that.tableData = res.result.list;
        that.total = res.result.total;
      });
    },
    remove (row) {
      let that = this;
      that.$confirm("确定删除该内容吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 调用接口
          fetch.remove({ id: row.id }).then((res) => {
            if (res.code == 200) {
              that.$message.success(res.message);
              that.getList();
            } else {
              that.$message.error(res.message);
            }
          });
        })
        .catch(() => { });
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  min-height: calc(100vh - 98px);
}
</style>
